import { combineReducers } from 'redux';
import topNavigationStyles from './TopNavigationStyles';

const rootReducer = combineReducers({
  topNavigationStyles
});

export default rootReducer;